import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'CareerAiRateLimitBanner',
  props: {
  dailyLimit: {
    type: Number,
    required: true
  },
  // プライム会員か。未加入なら加入導線を出す
  isPrime: {
    type: Boolean,
    default: false
  }
},
  emits: ['cta-click'],
  setup(__props) {





return { __sfc: true, }
}

})